import React from "react";

const Password = props => {
  const { value, valueChange, disabled, autoComplete, required, has_error, ...other } = props;

  return (
    <>
      <input style={{ display: "none" }} />
      <input
        data-required={required}
        data-required-valid={required && !!value}
        data-has-error={has_error}
        autoComplete="off"
        disabled={disabled}
        type={!!value || autoComplete !== "off" ? "password" : "text"}
        value={value}
        onChange={__ev => {
          valueChange(__ev.target.value);
        }}
        {...other}
      />
      <input style={{ display: "none" }} />
    </>
  );
};

export default Password;
